import React from 'react';
import '../../App.css';
import MrBillingForm from '../MrBillingForm';

function MrBilling({ sessionObject }) {
    // if (!sessionObject.sessionVariables["modules"].includes("Mrbilling")) {
    //     return;
    // }
    return (
        <div className="page-mr">
            <MrBillingForm sessionObject={sessionObject} />
        </div>
    );
}

export default MrBilling;